export default __webpack_public_path__ + "static/media/CNo.65-1.f833ae67.jpg";